<template>
  <div>
    <b-row>
      <!-- people group 1 -->
      <b-col md="3">
        <b-card>
          <b-card-text>
            <!-- draggable -->
            <input
              type="text"
              name=""
              v-model="qr"
              class="form-control"
              id=""
            />
            <draggable
              :list="list1"
              @remove="reset"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move full"
              style="height: 400px; overflow-y: auto"

            >
              <b-list-group-item
                v-for="(listItem, index) in list1.filter(
                  (a) => a.full_name.includes(qr) || a.email.includes(qr)
                )"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :src="listItem.profile_image_path" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.full_name }}
                    </b-card-text>
                    <small>{{ listItem.email }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
          </b-card-text>
        </b-card>
      </b-col>

      <!-- people group 2 -->
      <b-col md="9" class="mt-sm-2 mt-md-0">
        <b-card-group deck>
          <b-card
            border-variant="info"
            header="مشـرف"
            header-bg-variant="info"
            header-text-variant="white"
          >
            <draggable
              :list="supervisor"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move full"
            >
              <b-list-group-item
                v-for="(listItem, index) in supervisor"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :src="listItem.profile_image_path" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.full_name }}
                    </b-card-text>
                    <small>{{ listItem.email }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
          </b-card>

  
        </b-card-group>
        <b-card-group deck>
          <b-card
            border-variant="info"
            header="مناقش اول"
            header-bg-variant="info"
            header-text-variant="white"
          >
            <draggable
              :list="discussion_1"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move full"
            >
              <b-list-group-item
                v-for="(listItem, index) in discussion_1"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :src="listItem.profile_image_path" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.full_name }}
                    </b-card-text>
                    <small>{{ listItem.email }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
          </b-card>

          <b-card
            border-variant="success"
            header-bg-variant="success"
            header-text-variant="white"
            header="مناقش ثاني"
          >
            <draggable
              :list="discussion_2"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move full"
            >
              <b-list-group-item
                v-for="(listItem, index) in discussion_2"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :src="listItem.profile_image_path" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.full_name }}
                    </b-card-text>
                    <small>{{ listItem.email }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
          </b-card>
        </b-card-group>
        <b-card-group deck>
          <b-card
            border-variant="warning"
            header="رئيس الجلسة"
            header-bg-variant="warning"
            header-text-variant="white"
          >
            <draggable
              :list="chairman"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move full"
            >
              <b-list-group-item
                v-for="(listItem, index) in chairman"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :src="listItem.profile_image_path" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.full_name }}
                    </b-card-text>
                    <small>{{ listItem.email }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
          </b-card>

          <b-card
            border-variant="danger"
            header-bg-variant="danger"
            header-text-variant="white"
            header="رئيس القسم"
          >
            <draggable
              :list="chief_of_department"
              tag="ul"
              group="people"
              class="list-group list-group-flush cursor-move full"
            >
              <b-list-group-item
                v-for="(listItem, index) in chief_of_department"
                :key="index"
                tag="li"
              >
                <div class="d-flex">
                  <b-avatar :src="listItem.profile_image_path" />
                  <div class="ml-25">
                    <b-card-text class="mb-0 font-weight-bold">
                      {{ listItem.full_name }}
                    </b-card-text>
                    <small>{{ listItem.email }}</small>
                  </div>
                </div>
              </b-list-group-item>
            </draggable>
          </b-card>
        </b-card-group>
        <hr />
        <b-row>
          <b-col lg="12">
            <b-button block variant="primary" @click="submit()">
              <i class="fa fa-plus" /> {{ $t("site.save") }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import UsersController from "@/Controllers/UsersController";
import draggable from "vuedraggable";
import MastersController from "@/Controllers/MastersController";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      list1: [],
      copied : [],
      supervisor: [],
      discussion: [],
      chairman: [],
      chief_of_department: [],
      discussion_1: [],
      discussion_2: [],
      qr: "",
    };
  },
  async created() {
    new UsersController()
      .teachers({ filter: "master_supervise|1" })
      .then((res) => (this.list1 = res));
    const res = await new MastersController().Show(this.$route.params.master_id, { with: ["teachers"] });
    //  teachers[0].pivot.type
    this.supervisor = res.teachers.filter((a) => a.pivot.type == "supervisor");
    this.discussion = res.teachers.filter((a) => a.pivot.type == "discussion");
    this.chairman = res.teachers.filter((a) => a.pivot.type == "chairman");
    this.chief_of_department = res.teachers.filter(
      (a) => a.pivot.type == "chief_of_department"
    );
    this.discussion_1 = res.teachers.filter((a) => a.pivot.type == "discussion_1");
    this.discussion_2 = res.teachers.filter((a) => a.pivot.type == "discussion_2");

    console.log(res);
  },
  methods: {
    async submit() {
      let data = [];
      this.supervisor.forEach((element) => {
        data.push({type: "supervisor", user_id: element.id, master_id: this.$route.params.master_id});
      });
      this.discussion.forEach((element) => {
        data.push({type: "discussion", user_id: element.id,master_id: this.$route.params.master_id});

      });
      this.chairman.forEach((element) => {
        data.push({type: "chairman", user_id: element.id,master_id: this.$route.params.master_id});
      });
      this.chief_of_department.forEach((element) => {
        data.push({type: "chief_of_department", user_id: element.id,master_id: this.$route.params.master_id});
      });
      this.discussion_1.forEach((element) => {
        data.push({type: "discussion_1", user_id: element.id,master_id: this.$route.params.master_id});

      });
      this.discussion_2.forEach((element) => {
        data.push({type: "discussion_2", user_id: element.id,master_id: this.$route.params.master_id});

      });
      console.log(data);
      //related_id => ['pivot_field' => value],
      const res = new MastersController().updateTeachers({
        master_id: this.$route.params.master_id,
        data,
      });
    },
    reset(event) {
      //take a copy of the item and add it to the list

      
    },
  },
};
</script>
<style scoped>
.full {
  min-height: 100px;
  margin-right: -20px;
  margin-left: -20px;
}
.list-group-item {
  transition: all 1s;
}
</style>
 
 